export default __webpack_public_path__ + "static/media/Neophyte's Hood of Consumed Souls.8af4f21b.jpg";